module.exports = __webpack_public_path__ + "static/media/actify_logo.5ddca182.svg";